import { httpClient } from './httpClient';

const base = '/api/permisos';

export const listarPermisos = () => httpClient.get(base);
export const obtenerPermiso = (id) => httpClient.get(`${base}/${id}`);
export const crearPermiso = (payload) => httpClient.post(base, payload);
export const actualizarPermiso = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarPermiso = (id) => httpClient.del(`${base}/${id}`);

const permisosService = {
  listar: listarPermisos,
  obtener: obtenerPermiso,
  crear: crearPermiso,
  actualizar: actualizarPermiso,
  eliminar: eliminarPermiso,
};

export default permisosService;
